module.exports = __webpack_public_path__ + "static/media/Beekeeper.7510a19e.jpg";